/**
 * Format a number as Philippine Peso currency.
 * Example: 18450 → "₱18,450.00"
 */
export function formatCurrency(amount: number | undefined | null): string {
  if (amount == null) return "—";
  return `₱${amount.toLocaleString("en-PH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

/**
 * Format an ISO date string to a readable date.
 * Example: "2026-07-12" → "July 12, 2026"
 */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-PH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

/**
 * Format a period string to a readable label.
 * Example: "2026-07-H1" → "July 2026 (1–15)"
 *          "2026-07-H2" → "July 2026 (16–31)"
 */
export function formatPeriod(period: string): string {
  const match = period.match(/^(\d{4})-(\d{2})-(H[12])$/);
  if (!match) return period;
  const [, year, month, half] = match;
  const date = new Date(parseInt(year), parseInt(month) - 1, 1);
  const monthName = date.toLocaleDateString("en-PH", { month: "long" });
  if (half === "H1") {
    return `${monthName} ${year} (1–15)`;
  }
  const lastDay = new Date(parseInt(year), parseInt(month), 0).getDate();
  return `${monthName} ${year} (16–${lastDay})`;
}

/**
 * Format a full name from parts.
 */
export function formatFullName(firstName?: string, lastName?: string): string {
  if (!firstName && !lastName) return "Unknown";
  return [firstName, lastName].filter(Boolean).join(" ");
}

/**
 * Capitalize first letter of each word.
 */
export function titleCase(str: string): string {
  return str
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
